<template>

  <div class="main-container">

    <section v-if="loaded" class="container mt-0 pt-0">

          <div class="row m-0 pb-3 p-0 bg-white">
            
            <div class="col-12 col-md-6 offset-md-3 mt-4">

              <div class="row">

                <div class="col-4">
                  <b-img v-if="image" rounded="circle" :src="getImagePath(image, {width: 120,})" blank-color="#ccc" alt="placeholder" class="light-grey-border artist-image mr-2"></b-img>
                  <b-img v-else rounded="circle" blank blank-color="#ccc" alt="placeholder" class="light-grey-border artist-image mr-2"></b-img>
                </div>

                <div class="pl-0 col-8">
                  <h5 class="font-weight-normal dark-text mb-1 mt-2 ">{{username}}</h5>
                  <p class="font-weight-light mb-1 mt-2">The track you have selected to play requires a subscription</p>
                </div>
                
              </div>

            </div>

            <div id="chipin-form" class="col-12 col-md-6 offset-md-3 mt-2">


              <b-row class="mt-4">
                <b-col cols="12" sm="8" md="8" offset-md="2">
                  <b-row>

                    <b-col cols="2" offset="1" class="text-right pr-0">
                      <img src="../assets/tick.png" alt=""  >
                    </b-col>
                    <b-col class="pr-0">
                      <p class="font-weight-light mb-1 mt-1">Unlock to all of this Artist’s Tracks</p>
                    </b-col>

                  </b-row>
                  <b-row class="mt-3">

                    <b-col cols="2" offset="1" class="text-right pr-0">
                      <img src="../assets/tick.png" alt=""  >
                    </b-col>
                    <b-col class="pr-0">
                      <p class="font-weight-light mb-1 mt-1">Support the Artist and their Music</p>
                    </b-col>

                  </b-row>
                  <b-row class="mt-3 mb-3">

                    <b-col cols="2" offset="1" class="text-right pr-0">
                      <img src="../assets/tick.png" alt=""  >
                    </b-col>
                    <b-col class="pr-0">
                      <p class="font-weight-light mb-1 mt-1">Direct Message the Artist<sup>*</sup> </p>
                    </b-col>

                  </b-row>
                  <b-row class="mt-3 mb-3">

                    <b-col cols="2" offset="1" class="text-right pr-0">
                      <img src="../assets/tick.png" alt=""  >
                    </b-col>
                    <b-col class="pr-0">
                      <p class="font-weight-light mb-1 mt-1">Cancel anytime</p>
                    </b-col>

                  </b-row>
                </b-col>
              </b-row>
              
              <p class="text-center mt-3">
                <b-button class="px-5 py-2 rounded-btn" size="md" variant="info" @click="confirmPayment">
                  Subscribe for just {{price}}
                </b-button>
                <router-link class="text-link d-block font-weight-light my-0 py-0 mt-1" style="color: #555555; font-size: 14px;" to="/tell-me-more">Why do i need to subscribe?</router-link>

                <span class="text-center d-block my-3 text-info font-weight-light">or</span>

                <b-button class="mb-4 px-5 py-2 rounded-btn font-weight-bold" size="md" variant="outline-info" @click="startRadio">
                  Start Free Artist Radio
                </b-button>
                <br>
                <span style="color: #555555; font-size: 14px;" class="d-block">Play a random track from this artist and tracks from other artists in this genre</span>
              </p>

              <p class="text-center font-weight-light super-small mt-4 pb-3">
                By proceeding you agree to our <a href="https://trackdmusic.com/legal" class="text-secondary terms">terms</a>
              </p>

            </div>


        </div>

      </section>

  </div>
  
</template>

<script src="https://js.stripe.com/v3/"></script>

<script>
  import axios from "axios";
  import { validationMixin } from "vuelidate";

  export default {
    name: 'ChipIn',
    mixins: [validationMixin],
    data () {
        return {
          spk: process.env.VUE_APP_STRIPE_KEY,
          stripe:undefined,
          connected_account: null,
          username: null,
          image: null,
          price: null,
          data: {},
          form_error: null,
          checkout_session_id: null,
          payment_loading: false,
          loaded: false
        }
      },
    methods: {
      confirmPayment() {

      var self = this;

      let token = null;
      let payment_to = null;

      try {
        token = this.$store.getters.getToken.access;
      } catch (err) {
        self.$router.replace({name: 'auth-error'})
      }

      try {
        payment_to = self.$store.state.payment_to.payment_to;
      } catch (err) {
        this.$router.replace({name: 'auth-error'})
      }

      let headers = {
        'Authorization': 'JWT ' + token
      }

        axios.post('/chipin/api/plus/payment/', {
              "payment_type": 'subscription', //self.chipin_form.payment_type,
              //"currency": self.chipin_form.currency,
              //"amount": self.chipin_amount_payment,
              "payment_to": parseInt(payment_to)
        }, {'headers': headers}
        )
        .then(res => {

          self.checkout_session_id = res.data.checkout_session_id;
          self.connected_account = res.data.connected_account;

          return self.stripe.redirectToCheckout({ 
            sessionId: res.data.checkout_session_id,
          })
          
        })
        .catch(error => {
          console.log(error)
          self.payment_loading = false
          return
        });

      },   
      startRadio () {

        let play_radio = true;

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.SuccessHandler) {
            window.webkit.messageHandlers.SuccessHandler.postMessage({
                "play_radio": play_radio
            });
        }

      }        
    },
    computed: {
      chipin_amount_payment () {

        if (this.chipin_form.other) {
            return (Number(this.chipin_form.other_amount) * 100)
        } else {
          return this.chipin_form.amount
        }
      
      },
      chosen_currency () {
        
        if (this.chipin_form.currency) {

          if (this.chipin_form.currency == 'gbp') {
            return '£'
          }
          if (this.chipin_form.currency == 'eur') {
            return '€'
          }
          if (this.chipin_form.currency == 'usd') {
            return '$'
          }

        } else {

          return null

        }

      }
      
    },
    mounted: function () {

      var self = this;

      // GET Connected account

      axios.post('/chipin/api/checkout/account/', {
            "id": parseInt(self.$store.state.payment_to.payment_to)
        })
        .then(res => {

          this.username = res.data.username
          this.image = res.data.image
          this.price = res.data.chipin_plus_price
          this.$store.dispatch('storePhoto', res.data.image)

          var spk = null
          if (res.data.stripe_account_type === 'ssh') {
            spk = process.env.VUE_APP_STRIPE_KEY
          } else {
            spk = process.env.VUE_APP_STRIPE_TCLLC_KEY
          }

          self.stripe = Stripe(spk, {stripeAccount: res.data.id});

          this.loaded = true


        })
        .catch(error => {
          console.log(error)
          return
        });
      
    },
  }

</script>

<style scoped>

  .terms {
    text-decoration: underline;
  }

  .terms:hover {
    text-decoration: none;
  }

  .light-grey-border {
    border: 2px solid #9B9B9B
  }

  .red-text {
    color: #FF0000;
  }
  
  .dark-text {
    color: #595959;
  }

  .super-small {
    font-size: 0.7em;
    color: #595959;
  }

  .rounded-btn {
    border-radius: 10px;
  }

  .artist-image {
    width: 120px;
    height: 120px;
  }

  @media (max-width: 575.98px) {

    .artist-image {
      width: 100px;
      height: 100px;
    }


  }


  @media (max-width: 375.98px) {

    .artist-image {
      width: 80px;
      height: 80px;
    }


  }

</style>